import { BaseApiResponse, ThirdParty } from '@enmon/commons/lib/tools';
import type { Commodity } from '@enmon/commons/lib/shared';
import { Nullable } from '@enmon/commons';
import { BaseApiClient } from './baseApiClient';
import { Authenticator } from '../httpClient';

export interface ThirdPartiesFilter {
  commodity?: Nullable<Commodity>;
}

export class ThirdPartiesApiClient extends BaseApiClient<ThirdParty> {
  constructor(authenticator: Authenticator | undefined) {
    super('third-parties', authenticator);
  }

  async find({ commodity }: ThirdPartiesFilter, options: { signal?: AbortSignal } = {}) {
    return await this.http.get<BaseApiResponse<ThirdParty[]>>('', {
      params: commodity
        ? {
            filters: {
              commodities: {
                $containsi: commodity,
              },
            },
          }
        : undefined,
      ...options,
    });
  }
}
